@if (canRenderShell()) {
  <div class="root" [class.focus]="isFocus()" [class.panorama-layout]="!isFocus()">
    <inexp-header
      [appTitle]="header().appTitle"
      [navigation]="header().navigation"
      [secondaryNavigation]="header().secondaryNavigation"
      [showSecondaryNavigation]="header().showSecondaryNavigation"
      [showSearch]="header().showSearch"
      [showFeedbackButton]="header().showFeedbackButton"
      [feedbackButtonTitle]="header().feedbackButtonTitle"
    ></inexp-header>

    @if (isFocus()) {
      <router-outlet></router-outlet>
    } @else {
      <div class="panorama-content">
        <router-outlet></router-outlet>
      </div>
    }

    <inexp-footer
      [navigation]="footer.navigation"
      [disclaimer]="footer.disclaimer"
      [sitemap]="footer.sitemap"
    ></inexp-footer>
  </div>
} @else if (hasLoginFailed()) {
  <!-- The loop-breaker in authGuard has tripped, or the watchdog gave up:
       nothing further happens on its own, so this is a dead end unless the user
       asks for another attempt.

       Header and footer are withheld too, so this screen carries the page's
       only landmark and heading. No live region here — the panel is created
       with its text already inside, which does not reliably announce; the
       focus move onto the heading is what tells a screen reader it arrived. -->
  <main class="auth-gate">
    <div class="auth-gate-panel">
      <h1
        #failureHeading
        tabindex="-1"
        class="ui-heading-2-bold auth-gate-title"
      >
        We couldn't sign you in
      </h1>
      <p class="ui-body-m auth-gate-text">
        Roche sign-in returned without granting access. This usually clears on a
        second attempt; if it does not, contact the Panorama team.
      </p>
      <button rds-primary-button size="m" (click)="retryLogin()">
        Try again
      </button>
    </div>
  </main>
} @else {
  <main class="auth-gate">
    <div class="auth-gate-panel">
      <!-- RDS ships the spinner as an unnamed progressbar, so axe would fail
           it on its own. The heading below serves as its accessible name. -->
      <rds-progress-spinner mode="indeterminate" size="m" aria-hidden="true" />
      <h1 class="ui-heading-2-bold auth-gate-title">Signing you in</h1>
      <!-- Pending and redirecting share this branch, so the element survives the
           transition and the text swap does announce. -->
      <p class="ui-body-m auth-gate-text" role="status">
        {{ signInMessage() }}
      </p>
    </div>
  </main>
}
